import { EventEmitter, Output, Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  SellSort,
  SearchService,
  InventoryManagementState,
  UpdateSearchRequest,
  InventoryManagementBookValueProvider,
  InventoryManagementSearchRequest
} from 'remarketing-angular-library';
import { SellSortServiceV2 } from '../../services/sell-sort/sell-sort.service';
import { DropdownSelectComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'lib-search-results-sort-select-v2',
  templateUrl: './search-results-sort-select.component.html',
  styleUrls: ['./search-results-sort-select.component.scss'],
  imports: [TrapFocusComponent, DropdownSelectComponent, AsyncPipe]
})
export class SearchResultsSortSelectComponentV2 {
  @Input() label: string = '';
  @Input() stacked = false;
  @Output() public sortSelectionChangedEvent = new EventEmitter<string>();
  enableFocusTrap = false;

  constructor(
    private readonly store: Store,
    readonly sellSortService: SellSortServiceV2,
    private readonly searchService: SearchService
  ) {
  }

  public updateSort(option) {
    if (option?.dataset?.value) {
      const sortOption = option.dataset.value ? option.dataset.value.split('__') : ['', ''];

      const currentRequest = this.store.selectSnapshot(InventoryManagementState.searchRequest);

      const payload: InventoryManagementSearchRequest = {
        ...currentRequest,
        searchCriteria: {
          ...currentRequest?.searchCriteria,
          sortBy: sortOption[0],
          sortOrder: sortOption[1]
        },
        page: 0,
      };

      // Include Book Value Provider if sorting by average book value
      if (option.dataset.value === SellSort.AVERAGE_BOOK_VALUE__DESC || option.dataset.value === SellSort.AVERAGE_BOOK_VALUE__ASC) {
        let preferences = this.searchService.searchPreferences.getValue();
        if (!preferences) {
          this.searchService.getLoadPreferences();
          preferences = this.searchService.searchPreferences.getValue();
        }
        if (preferences?.bookSpread?.bookValueSpreadType) {
          payload.searchCriteria.bookValueProvider =
            preferences.bookSpread.bookValueSpreadType as InventoryManagementBookValueProvider;
        }
      } else {
        payload.searchCriteria.bookValueProvider = null;
      }
      this.store.dispatch(new UpdateSearchRequest(payload));
    }
  }

  onOpenChange(e: boolean) {
    this.enableFocusTrap = e;
  }
}
